var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Grid, MenuItem, IconButton, Switch, Tooltip } from '@mui/material';
import { VisibilityOutlined as VisibilityOutlinedIcon, ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon, Search as SearchIcon, } from '@mui/icons-material';
import { MODOS } from '../../../utils';
import { ROUTES, FUNCIONALIDADES, PAGINAS } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { BotaoAdicionar, BotaoAuxiliar } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import GridComp, { PaginationModelDefault } from '../../../components/grid';
import { BoxPrincipal, BoxSuperior, BoxGrid } from '../../../components/grid_box';
import { useNavigate } from 'react-router-dom';
import { getJustificativas, excluirJustificativa, alterarSituacaoJustificativa, STATUS_API } from './controle_justificativas.service';
export var ControleJustificativasListar = function () {
    var navigate = useNavigate();
    var _a = useState(true), isLoading = _a[0], setIsLoading = _a[1];
    // Inputs dos filtros
    var _b = useState(''), FiltroJustificativa = _b[0], setFiltroJustificativa = _b[1];
    var _c = useState(''), FiltroCodigo = _c[0], setFiltroCodigo = _c[1];
    var _d = useState(''), FiltroDescricao = _d[0], setFiltroDescricao = _d[1];
    var _e = useState(''), FiltroStatus = _e[0], setFiltroStatus = _e[1];
    // Filtros efetivamente aplicados (disparam a consulta)
    var _f = useState({}), FiltrosAplicados = _f[0], setFiltrosAplicados = _f[1];
    var _g = useState([]), Justificativas = _g[0], setJustificativas = _g[1];
    var _h = useState(0), TotalRegistros = _h[0], setTotalRegistros = _h[1];
    var _j = useState(PaginationModelDefault), PaginationModel = _j[0], setPaginationModel = _j[1];
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.GF_CONTROLE_JUSTIFICATIVAS); }, [getAcoesFuncionalidade]);
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PaginationModel, FiltrosAplicados]);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resposta, dados, total_registros;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, getJustificativas(FiltrosAplicados, PaginationModel)];
                case 1:
                    Resposta = _a.sent();
                    if (Resposta.Status == STATUS_API.ERRO) {
                        alert(Resposta.Mensagem);
                    }
                    else {
                        dados = Resposta.dados, total_registros = Resposta.total_registros;
                        setJustificativas(dados);
                        setTotalRegistros(total_registros);
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // Busca "contém": filtros de texto só são aplicados a partir do 3º caractere.
    var pesquisar = function () {
        var filtros = {};
        if (FiltroJustificativa.trim().length >= 3)
            filtros.justificativa = FiltroJustificativa.trim();
        if (FiltroCodigo.trim())
            filtros.codigo = FiltroCodigo.trim();
        if (FiltroDescricao.trim().length >= 3)
            filtros.descricao = FiltroDescricao.trim();
        if (FiltroStatus)
            filtros.situacao = FiltroStatus;
        setPaginationModel(function (prev) { return (__assign(__assign({}, prev), { page: 0 })); });
        setFiltrosAplicados(filtros);
    };
    var limparFiltros = function () {
        setFiltroJustificativa('');
        setFiltroCodigo('');
        setFiltroDescricao('');
        setFiltroStatus('');
        setPaginationModel(function (prev) { return (__assign(__assign({}, prev), { page: 0 })); });
        setFiltrosAplicados({});
    };
    var navegar = function (id, modo) {
        navigate("".concat(ROUTES.GF_CONTROLE_JUSTIFICATIVAS, "/").concat(id, "/").concat(modo));
    };
    var excluir = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm('Tem certeza que deseja excluir esta justificativa? Esta ação é irreversível.'))
                        return [2 /*return*/];
                    setIsLoading(true);
                    return [4 /*yield*/, excluirJustificativa(String(id))];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        alert('Registro excluído com sucesso!');
                        carregarDados();
                    }
                    else {
                        setIsLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao excluir a justificativa');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var alternarSituacao = function (id, situacaoAtual) { return __awaiter(void 0, void 0, void 0, function () {
        var nova, Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nova = situacaoAtual === 'Ativo' ? 'Inativo' : 'Ativo';
                    setIsLoading(true);
                    return [4 /*yield*/, alterarSituacaoJustificativa(String(id), nova)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        carregarDados();
                    }
                    else {
                        setIsLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao alterar a situação');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var COLUNAS = [
        { field: 'codigo', headerName: 'Código', width: 140 },
        { field: 'nome', headerName: 'Justificativa', width: 260 },
        { field: 'descricao_resumida', headerName: 'Descrição', flex: 1, minWidth: 240 },
        { field: 'situacao', headerName: 'Status', width: 110 },
        {
            field: 'acoes',
            headerName: 'Ações',
            width: 200,
            sortable: false,
            align: 'right',
            headerAlign: 'right',
            renderCell: function (params) { return (_jsxs(Box, __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }, { children: [_jsx(IconButton, __assign({ "aria-label": 'visualizar', color: 'warning', onClick: function () { return navegar(params.row.id, MODOS.VISUALIZAR); } }, { children: _jsx(VisibilityOutlinedIcon, {}) })), _jsx(IconButton, __assign({ "aria-label": 'editar', color: 'primary', onClick: function () { return navegar(params.row.id, MODOS.ALTERAR); }, disabled: AcoesFuncionalidade['ALTERAR'] === false }, { children: _jsx(ModeEditOutlinedIcon, {}) })), _jsx(IconButton, __assign({ "aria-label": 'excluir', color: 'error', onClick: function () { return excluir(params.row.id); }, disabled: AcoesFuncionalidade['EXCLUIR'] === false }, { children: _jsx(DeleteOutlineIcon, {}) })), _jsx(Tooltip, __assign({ title: params.row.situacao === 'Ativo' ? 'Desativar' : 'Ativar' }, { children: _jsx(Switch, { size: 'small', color: 'success', checked: params.row.situacao === 'Ativo', onChange: function () { return alternarSituacao(params.row.id, params.row.situacao); }, disabled: AcoesFuncionalidade['ALTERAR'] === false }) }))] }))); },
        },
    ];
    return (_jsx(ContainerPainel, __assign({ pagina: PAGINAS.GF_CONTROLE_JUSTIFICATIVAS, pagina_especifica_permissao: FUNCIONALIDADES.GF_CONTROLE_JUSTIFICATIVAS }, { children: _jsxs(BoxPrincipal, { children: [_jsxs(BoxSuperior, { children: [_jsx(Box, { sx: { flexGrow: 1 } }), _jsx(BotaoAdicionar, { pagina: ROUTES.GF_CONTROLE_JUSTIFICATIVAS, label: 'Incluir Justificativa' })] }), _jsxs(Grid, __assign({ container: true, spacing: 2, sx: { mb: 1 } }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'filtro_justificativa', label: 'Justificativa', value: FiltroJustificativa, onChange: function (e) { return setFiltroJustificativa(e.target.value); }, inputProps: { maxLength: 50 } }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'filtro_codigo', label: 'C\u00F3digo da Justificativa', value: FiltroCodigo, onChange: function (e) { return setFiltroCodigo(e.target.value.replace(/\D/g, '').substring(0, 15)); }, inputProps: { maxLength: 15, inputMode: 'numeric' } }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'filtro_descricao', label: 'Descri\u00E7\u00E3o Resumida', value: FiltroDescricao, onChange: function (e) { return setFiltroDescricao(e.target.value); }, inputProps: { maxLength: 150 } }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'filtro_status', label: 'Status', value: FiltroStatus, onChange: function (e) { return setFiltroStatus(e.target.value); } }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: "Todos" })), _jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })) })), _jsxs(Grid, __assign({ item: true, xs: 12, display: 'flex', justifyContent: 'flex-end', gap: 1 }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'secondary.main', onClick: limparFiltros }, { children: "Limpar Filtros" })), _jsx(BotaoAuxiliar, __assign({ backgroundColor: 'primary.main', startIcon: _jsx(SearchIcon, {}), onClick: pesquisar }, { children: "Pesquisar" }))] }))] })), _jsx(BoxGrid, { children: _jsx(GridComp, { columns: COLUNAS, rows: Justificativas, TotalRegistros: TotalRegistros, isLoading: isLoading, PaginationModel: PaginationModel, setPaginationModel: setPaginationModel, initialState: { sorting: { sortModel: [{ field: 'codigo', sort: 'asc' }] } } }) })] }) })));
};
export default ControleJustificativasListar;
